/**
 * When the browser blocks reading a cross-origin response (missing CORS headers),
 * axios often surfaces `ERR_NETWORK` / "Network Error" with no `error.response`.
 * The request may still have succeeded (e.g. 201 visible only in DevTools Network).
 */
export function isLikelyCorsOrOpaqueNetworkReadBlocked(error) {
	if (!error || error.response != null) {
		return false;
	}
	if (error.code === "ERR_NETWORK") {
		return true;
	}
	return /network error/i.test(String(error.message || ""));
}
